import React from 'react'

const HtmlFields = ({ htmlContent }) => {
  return (
    <div><p dangerouslySetInnerHTML={{ __html: htmlContent }} /></div>
  )
}

export default HtmlFields